<template functional>
  <div class="pa-1 d-inline-block">
    <v-img
      max-width="30"
      max-height="30"
      :src="props.logoUrl"
      contain
    />
  </div>
</template>
<script>

export default {
  logoUrl: {
    type: String,
    required: true,
  },
};
</script>
